// extracted by mini-css-extract-plugin
module.exports = {"Files":"Files_Files__mIWSI","uploadBtn":"Files_uploadBtn__7hBr0","addFile":"Files_addFile__1ENXJ"};